module.exports = __webpack_public_path__ + "img/pic_tltw_pszsy_selected@2x.d193224c.png";